import { render } from "./TopMenu.vue?vue&type=template&id=13f98809&scoped=true&ts=true"
import script from "./TopMenu.vue?vue&type=script&lang=ts"
export * from "./TopMenu.vue?vue&type=script&lang=ts"

import "./TopMenu.vue?vue&type=style&index=0&id=13f98809&scoped=true&lang=scss"

import exportComponent from "/home/steffen/IdeaProjects/Antara/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13f98809"]])

export default __exports__